// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_visitor,
  add_visitor,
  update_visitor,
  delete_visitor,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    today.setMinutes(today.getMinutes() - offset);
    return today.toISOString().split("T")[0];
  };
const initialState = {
  visitors: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name:'',
    photo:'',
    date:'',
    mobile_number:'',
    relation_with_parent:'',
    description:'',
    time_slot:''
  },
};

 
export const fetchvisitor = createAsyncThunk(
  "visitor/fetchvisitor",
  async (
    { page, page_size, school_id,token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_visitor(
        page,
        page_size,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createvisitor = createAsyncThunk(
  "visitor/createvisitor",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_visitor(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updatevisitor = createAsyncThunk(
  "visitor/updatevisitor",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_visitor(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deletevisitor = createAsyncThunk(
  "visitor/deletevisitor",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_visitor({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// Class Slice
const visitorSlice = createSlice({
  name: "visitors",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
      EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
        name:'',
        photo:'',
        mobile_number:'',
        relation_with_parent:'',
        description:'',
        time_slot:''
      };
    },
    setvisitor(state, action) {
      state.visitors = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchvisitor.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchvisitor.fulfilled, (state, action) => {
        state.loading = false;
        state.visitors = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchvisitor.rejected, (state, action) => {
        state.loading = false;
        state.visitors = []
        state.error = action.payload;
      })

      // Add Class
      .addCase(createvisitor.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createvisitor.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createvisitor.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatevisitor.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatevisitor.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatevisitor.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deletevisitor.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletevisitor.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletevisitor.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      });
  },
});

// Export the actions and the reducer
export const {
  setvisitor,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,
} = visitorSlice.actions;
export default visitorSlice.reducer;
